import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { RoleService } from './role.service';
import { map, take, tap } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.user$.pipe(
    take(1),
    map(user => !!user),
    tap(loggedIn => { if (!loggedIn) router.navigate(['/login']); }),
  );
};

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const roleService = inject(RoleService);
  const router = inject(Router);
  return auth.orgUser$.pipe(
    take(1),
    map(u => u?.role === 'admin' || u?.role === 'owner'),
    tap(ok => {
      if (!ok) {
        router.navigate([roleService.isCollector() ? '/record-donation' : '/dashboard']);
      }
    }),
  );
};

export const ownerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const roleService = inject(RoleService);
  const router = inject(Router);
  return auth.orgUser$.pipe(
    take(1),
    map(u => u?.role === 'owner'),
    tap(ok => {
      if (!ok) {
        router.navigate([roleService.isCollector() ? '/record-donation' : '/dashboard']);
      }
    }),
  );
};
